import React, { useState, useEffect, useContext } from 'react'
import { useParams, Redirect } from 'react-router-dom'

import { LaboratoryService } from '../../services/Laboratory'
import { PodsService } from '../../services/Pods'

import { Message } from 'primereact/message'
import { Context } from '../../Context'
import { GLOBALS } from '../../utils/Globals'
import { LaboratoriesForm } from '../../components/LaboratoriesForm'
import { Layout } from '../../components/Layout'

import './styles.scss'

export const CreateEditLaboratories = () => {
  const { id: idToEdit } = useParams()
  const { isAuth: token } = useContext(Context)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [LaboratoriesToEdit, setLaboratoriesToEdit] = useState([])
  const [redirectTo, setRedirectTo] = useState(null)
  const [podsList, setPodsList] = useState([])
  const [podsListToEdit, setPodsListToEdit] = useState([])

  const config = {
    title: 'Crear Laboratorio',
    icon: GLOBALS.menu.laboratories.icon,
    link: GLOBALS.menu.laboratories.link,
    linkList: GLOBALS.menu.laboratories.linkList,
  }

  if (idToEdit) {
    config.title = 'Editar laboratorio'
  }

  const fetchData = async () => {
    try {
      setIsLoading(true)
      const [laboratories, podList, podsListToEdit] = await Promise.all([
        (async () => {
          if (idToEdit) {
            return await LaboratoryService.getById(idToEdit, token)
          }
          return null
        })(),
        PodsService.getAll(token),
        (async () => {
          if (idToEdit) {
            try {
              return await LaboratoryService.getById(idToEdit, token)
            } catch (error) {
              return []
            }
          }
          return null
        })(),
      ])

      setLaboratoriesToEdit(laboratories)

      setPodsList(
        podList.map((u) => {
          return {
            label: `${u.name}`,
            value: u.id,
          }
        })
      )

      if (idToEdit) {
        if (podsListToEdit) {
          setPodsListToEdit(
            podsListToEdit.pods.map((u) => {
              return {
                label: `${u.name}`,
                value: u.id,
              }
            })
          )
        }
      }
    } catch (e) {
      setError(e.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)

      if (idToEdit) {
        // Crear un nuevo FormData sin los campos fileType y topologyType
        const res = new FormData()
        for (let [key, value] of data.entries()) {
          if (key !== 'fileType' && key !== 'topologyType') {
            res.append(key, value)
          }
        }
        console.log('Data being sent to update:', data)
        const response = await LaboratoryService.update(idToEdit, res, token)
        console.log('Response from update:', response)
      } else {
        console.log('Data being sent to create:', data)
        const response = await LaboratoryService.create(data, token)
        console.log('Response from create:', response)
      }

      setIsLoading(false)
      setError(null)

      setRedirectTo({
        pathname: config.linkList,
        state: { success: true },
      })
    } catch (e) {
      console.error('Error in onSubmit:', e)
      setIsLoading(false)
      setError(e.message)
    }
  }

  if (redirectTo) {
    return <Redirect to={redirectTo} />
  }

  return (
    <Layout>
      {isLoading || (!LaboratoriesToEdit && idToEdit) ? (
        <div className="loading-container">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
        </div>
      ) : error ? (
        <Message severity="error" text={error}></Message>
      ) : (
        <div className="p-fluid">
          <div className="p-grid">
            <div className="p-col-12">
              <div className="card card-w-title">
                <h1 className="create-edit-title">
                  {config.icon && <i className={config.icon}></i>}
                  {config.title}
                </h1>

                <LaboratoriesForm
                  item={LaboratoriesToEdit}
                  isLoading={isLoading}
                  podsList={podsList}
                  podsListToEdit={podsListToEdit}
                  onSubmit={onSubmit}
                  cancelLink={config.linkList}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  )
}
